import type { ReactNode } from 'react';
import { Halftone, type HalftoneType } from './Halftone';
import './EmptyState.css';

interface Props {
  eyebrow?: string;
  headline: string;
  body?: string;
  cta?: ReactNode;
  align?: 'center' | 'start';
  tone?: 'default' | 'compact';
  /** Background halftone pattern. Defaults to the faint 'whisper'; pass a
   *  fuller type (e.g. 'cloud') where a denser field is wanted. */
  halftone?: HalftoneType;
}

/**
 * Typography-forward empty state. No illustrations - all type.
 * Carmen display headline + Agenda kicker eyebrow (brand-pack v5).
 */
export function EmptyState({
  eyebrow = 'Nothing here yet',
  headline,
  body,
  cta,
  align = 'center',
  tone = 'default',
  halftone = 'whisper',
}: Props) {
  return (
    <div className={`empty empty--${align} empty--${tone}`}>
      <span className="empty__halftone" aria-hidden="true">
        <Halftone type={halftone} />
      </span>
      {eyebrow && <p className="empty__eyebrow">{eyebrow}</p>}
      <h2 className="empty__headline">{headline}</h2>
      {body && <p className="empty__body">{body}</p>}
      {cta && <div className="empty__cta">{cta}</div>}
    </div>
  );
}
